module.exports = __webpack_public_path__ + "media/images/webpage/hotels/539/floorguide/course-1-photo-1-d7ae7868b85de7e8a3f75b5867f76a9d.webp";